import React, { useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { API_BASE_URL } from "../../utils/api";

const Result = () => {
    return (
        <p className="success-message" style={{ color: '#28a745', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FiCheckCircle size={20} />
            Your message has been successfully sent. We will contact you soon.
        </p>
    )
}

function ContactForm({props , formStyle}) {
    const [ result, showresult ] = useState(false);
    const [ submitting, setSubmitting ] = useState(false);
    const [ error, setError ] = useState(null);

    const API_URL = API_BASE_URL;

    const sendEmail = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError(null);
        showresult(false);

        const formData = {
            fullname: e.target.fullname.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            subject: e.target.subject.value,
            message: e.target.message.value
        };

        try {
            const response = await fetch(`${API_URL}/contact/submit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
                e.target.reset();
                showresult(true);
                setTimeout(() => {
                    showresult(false);
                }, 5000);
            } else {
                setError(data.error || 'Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error sending contact form:', error);
            setError('Network error. Please check your connection and try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
            <div className="form-group">
                <input 
                type="text"
                name="fullname"
                placeholder="Your Name"
                required
                />
            </div>

            <div className="form-group">
                <input 
                type="email"
                name="email"
                placeholder="Email Address"
                required
                />
            </div>

            <div className="form-group">
                <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                pattern="[0-9]{10}"
                maxLength={10}
                title="Please enter a valid 10-digit phone number"
                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); }}
                required
                />
            </div>


            <div className="form-group">
                <input 
                type="text"
                name="subject"
                placeholder="Subject"
                required
                />
            </div>

            <div className="form-group">
                <textarea 
                name="message"
                placeholder="Your Message"
                required
                >
                </textarea>
            </div>

            <div className="form-group">
                <button 
                    className="btn-default btn-large" 
                    type="submit"
                    disabled={submitting}
                >
                    {submitting ? 'Submitting...' : 'Submit Now'}
                </button>
            </div> 

            <div className="form-group">
                {result ? <Result /> : null}
                {error && (
                    <p className="error-message" style={{ color: '#dc3545', marginTop: '10px' }}>
                        {error}
                    </p>
                )}
            </div> 
        </form>
    )
}
export default ContactForm;
